import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CallSipUser from '../../connection/sip';
import { GreenroomState } from '../../stores/types/types';

const SipConnector: React.FC = () => {
	const [sipAddress, setSipAddress] = useState('');
	const token = useSelector((state: GreenroomState) => state.SessionReducer.token);
	const meetingId = useSelector(
		(state: GreenroomState) => state.SessionReducer.meeting?.meeting_id,
	);

	return (
        <div>
            <input
                type="text"
                value={sipAddress}
                onChange={(e) => setSipAddress(e.target.value)}
            />
            <button onClick={() => CallSipUser(token ?? '', sipAddress, meetingId ?? '')}>Connect</button>
        </div>
	);
};

export default SipConnector;
